import { render, staticRenderFns } from "./member_config.vue?vue&type=template&id=3f6ce53e&scoped=true&"
import script from "./member_config.vue?vue&type=script&lang=ts&"
export * from "./member_config.vue?vue&type=script&lang=ts&"
import style0 from "./member_config.vue?vue&type=style&index=0&id=3f6ce53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6ce53e",
  null
  
)

export default component.exports